module.exports = __webpack_public_path__ + "img/mac10.0c2aef3e.svg";